
import {getApi} from "./auth";
import "./globals";

const checkPrivacy = async () => {
    let auth = getApi();
    let user = auth.getCached("userInfo");
    
    if (user && user.isAuthenticated && user.consensiIncompleti) {
        return await auth.fetchWithAuth("GET /privacy/consensiUtente")
    }
}

const consensiUtente = async () => {
    let auth = getApi();
    let user = auth.getCached("userInfo");
    
    if (user && user.isAuthenticated) {
        return await auth.fetchWithAuth("GET /privacy/consensiUtente")
    }
}

const salvaConsenso = async (id:number, codice:string, stato:number)=> {
    //TODO: rifare
    //TODO: la reject da qui va gestita nella PrivacyModal rigettando la userAction
    const auth = getApi();
    const userInfo = auth.getCached("userInfo");
    
    await auth.fetchWithAuth("PUT /privacy/consensiUtente?validateObbligatori=false", {
        body: JSON.stringify({consensi:[{
            consensoId: id,
            checked: (stato !== 0)
        }]})
    });
    // in caso di errore in salvataggio l'eccezione sale al chiamante
}



export { checkPrivacy, consensiUtente,salvaConsenso };